import { Checkbox } from "~/components/ui/checkbox.jsx";
import { Label } from "~/components/ui/label.jsx";
import { Badge } from "@/components/ui/badge.jsx";
import { Button } from "@/components/ui/button.jsx";
import { ScrollArea } from "@/components/ui/scroll-area.jsx";
import * as reactUse from "react-use";
import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import {cn} from '~/lib/utils';

const { useFirstMountState, useWindowSize } = reactUse;

export default function ({
  name,
  title,
  values = [],
  checked = [],
  onValuesChange = Function(),
  limit = 10,
}) {
  const isFirstMount = useFirstMountState();
  const [selected, setSelected] = useState(checked);
  const count = selected.length;

  useEffect(() => {
    if (!isFirstMount) {
      onValuesChange(selected);
    }
  }, [selected]);

  const [displayAllValues, setDisplayAllValues] = useState(false);
  const isScrollAreaNeedToBeRender = values.length > limit;

  const valuesToDisplay =
    !displayAllValues && isScrollAreaNeedToBeRender
      ? values.slice(0, limit)
      : values;

  const Comp =
    displayAllValues && isScrollAreaNeedToBeRender
      ? ({ children }) => (
          <ul>
            <ScrollArea className="h-[300px]">{children}</ScrollArea>
          </ul>
        )
      : ({ children }) => <ul>{children}</ul>;

  const reset = () => {
    setSelected([])
  }

  const addValue = (value) => {
    setSelected([...selected, value]);
  };

  const removeValue = (value) => {
    selected.splice(selected.indexOf(value), 1);
    setSelected([...selected]);
  };

  return (
    <div>
      {count > 0 && (
        <div className="flex justify-between border-b items-center py-1 mb-1">
          <div className="flex items-center space-x-2">
            <span>Выбрано:</span>
            <Badge className="h-5 max-w-5">{count}</Badge>
          </div>
          <Button
            variant="link"
            onClick={reset}
          >
            Сбросить
          </Button>
        </div>
      )}

      <Comp>
        {valuesToDisplay.map(({ value, label, key }) => {
          const isChecked = selected.includes(String(value));
          const id = `${name}-${value}`;

          return (
            <li
              className="cursor-pointer select-none flex items-center gap-3"
              key={`${key}-${value}`}
            >
              <Checkbox
                className="size-5"
                value={value}
                defaultChecked={isChecked}
                id={id}
                name={id}
                onCheckedChange={(checked) => {
                  if (checked) {
                    addValue(value);
                  } else {
                    removeValue(value);
                  }
                }}
              />
              <Label className="text-base font-normal" htmlFor={id}>
                {label}
              </Label>
            </li>
          );
        })}
      </Comp>

      {isScrollAreaNeedToBeRender && (
        <div>
          <Button
            variant="link"
            className="flex items-center"
            onClick={() => setDisplayAllValues(!displayAllValues)}
          >
            {displayAllValues ? "Скрыть" : "Показать все"} <ChevronDown className={cn(displayAllValues && 'transform rotate-180')} />
          </Button>
        </div>
      )}
    </div>
  );
}
